export default __webpack_public_path__ + "static/media/beginners_protector.19165915.png";